import React from 'react';
import PropTypes from 'react-proptypes';
import cx from 'classnames';

export default class ElementRequiredIndicator extends React.Component {
  static propTypes = {
    className: PropTypes.string,
    required: PropTypes.bool.isRequired,
  };

  render() {
    // @ts-ignore
    const { styles } = ElementRequiredIndicator;

    const classes = css(styles.container,
      // @ts-ignore
      !this.props.required && styles.hidden);

    return (
      // @ts-ignore
      <div className={cx(classes, this.props.className)}>*</div>
    );
  }
}
// @ts-ignore
const styles = cssInJS({
  container: {
    visibility: 'visible',
    width: '2%',
    color: 'red',
    fontWeight: 'bold',
    paddingTop: 13,

    '@phone': {
      display: 'block',
      position: 'absolute',
      right: 8,
      top: 0,
      width: 16,
      height: 16,
      zIndex: 10,
    },
  },

  hidden: {
    visibility: 'hidden !important',
  },
});
// @ts-ignore
ElementRequiredIndicator.styles = styles;
